export const GET_MOVIES_PENDING = 'GET_MOVIES_PENDING';
export const GET_MOVIES_FULFILLED = 'GET_MOVIES_FULFILLED';
export const GET_MOVIES_REJECTED = 'GET_MOVIES_REJECTED';
export const PATCH_MOVIES_ERROR = 'PATCH_MOVIES_ERROR';

export const GET_SEARCHES_PENDING = 'GET_SEARCHES_PENDING';
export const GET_SEARCHES_FULFILLED = 'GET_SEARCHES_FULFILLED';
export const GET_SEARCHES_REJECTED = 'GET_SEARCHES_REJECTED';
export const PATCH_SEARCHES_ERROR = 'PATCH_SEARCHES_ERROR';
export const PATCH_SEARCHES = 'PATCH_SEARCHES';
